import { useSWRDataTable } from "@bleu.builders/ui";
import { useNavigate } from "react-router-dom";

export function useSWRDataTableWithRedirect(
  path,
  initialSearch = {},
  options = {},
) {
  const navigate = useNavigate();

  const data = useSWRDataTable(path, initialSearch, {
    onError: (error) => {
      if (error.response?.status === 401) {
        // force a reload to redirect to the login pages
        navigate(0);
      } else {
        throw error;
      }
    },
    ...options,
  });

  return {
    ...data,
  };
}
